import React from "react";
import { Area } from "../assets/svg";
const DataPopUp = (props) => {
  let totusers = props.area.male + props.area.female;
  let totalFemalesPerc = Math.round((props.area.female / totusers) * 100);
  let totalMalesPerc = Math.round((props.area.male / totusers) * 100);
  let totalPro = Math.round((props.area.proCount / totusers) * 100);

  return (
    <div className="data">
      <div className="datapopup">
        {/* <CardWarapper>
        <p className="datapopup-title">Area Info</p>
      </CardWarapper> */}

        <CardWarapper>
          {props.areas ? (
            <>
              {" "}
              <AreaInfo area={props.area} />{" "}
            </>
          ) : (
            ""
          )}
          <div
            className="area-card-header-name"
            style={{ padding: "50px", paddingTop: "5px" }}
          >
            <div className="area-card-header-name-metric">
              <PercentageCard title="Pro - Users" percentage={totalPro} />
              <PercentageCard title="Female" percentage={totalFemalesPerc} />
              <PercentageCard title="Male" percentage={totalMalesPerc} />
            </div>
          </div>
        </CardWarapper>
        {props.areas
          ? props.areas.map((info, index) => {
              let coOrds = info.geometry.coordinates[0][0];
              let ln = coOrds[0];
              let lt = coOrds[1];

              let malePercentage = Math.round(
                (info.properties.maleCount / info.properties.userCount) * 100
              );
              let femalePercentage = Math.round(
                (info.properties.femaleCount / info.properties.userCount) * 100
              );
              let proPercentage = Math.round(
                (info.properties.proCount / info.properties.userCount) * 100
              );
              return (
                <CardWarapper key={index}>
                  <AreaCard
                    goToArea={props.getArea}
                    lt={lt}
                    ln={ln}
                    objectid={info.properties.objectid}
                    key={index}
                    proCount={info.properties.proCount}
                    userCount={info.properties.userCount}
                    name={info.properties.name}
                    malePercentage={malePercentage}
                    femalePercentage={femalePercentage}
                    proPercentage={info.properties.proCount}
                  />
                </CardWarapper>
              );
            })
          : ""}
        {props.areas
          ? props.areas.length === 1
            ? (() => {
                let area = props.areas[0].properties;

                return (
                  <CardWarapper>
                    <div
                      style={{
                        padding: "30px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <div style={{ flex: 0.7 }}>
                        <PercentageCard
                          title="Total Users"
                          percentage={
                            Number(area.maleCount) + Number(area.femaleCount)
                          }
                          userCount={true}
                        />
                        <PercentageCard
                          title="Female"
                          percentage={Number(area.femaleCount)}
                          userCount={true}
                        />
                        <PercentageCard
                          title="Male"
                          percentage={area.maleCount}
                          userCount={true}
                        />
                        <PercentageCard
                          title="Pro-Users"
                          percentage={area.proCount}
                          userCount={true}
                        />
                      </div>
                    </div>
                  </CardWarapper>
                );
              })()
            : ""
          : ""}
      </div>
    </div>
  );
};

const AreaInfo = ({ area }) => {
  return (
    <div className="area">
      <div className="area-info">
        <div className="area-info-hero">
          <p className="area-info-hero-title">{area.male + area.female}</p>
          <p className="area-info-hero-description">{area.description}</p>
        </div>
        <div className="area-info-metric">
          <div className="area-info-metric-pro">
            <p className="area-info-metric-pro-title">{area.proCount}</p>
            <p className="area-info-metric-pro-description">Pro Users</p>
          </div>
          <div className="area-info-metric-gender">
            <p className="area-info-metric-gender-title">{area.male}</p>
            <p className="area-info-metric-gender-description">Male</p>
          </div>
          <div className="area-info-metric-gender">
            <p className="area-info-metric-gender-title">{area.female}</p>
            <p className="area-info-metric-gender-description">Female</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const AreaCard = (area) => {
  return (
    <div className="area-card">
      <div className="area-card-header">
        <div className="area-card-header-icon">
          <Area />
        </div>
        <div className="area-card-header-name">
          <a
            className="area-card-header-name-name"
            onClick={() => {
              area.goToArea(area.objectid, area.ln, area.lt);
            }}
          >
            {area.name}
          </a>
          <div className="area-card-header-name-metric">
            <PercentageCard
              title="Total - Users"
              percentage={area.userCount}
              userCount={true}
            />
            <PercentageCard
              title="Pro - Users"
              percentage={area.proCount}
              userCount={true}
            />
            <PercentageCard title="Female" percentage={area.femalePercentage} />
            <PercentageCard title="Male" percentage={area.malePercentage} />
          </div>
        </div>
      </div>
    </div>
  );
};

const PercentageCard = ({ title, percentage, userCount }) => {
  let color =
    percentage < 30
      ? "red"
      : percentage > 80
      ? "green"
      : "hsla(212, 68%, 59%, 0.79)";
  return (
    <div className="percentage-card">
      <p className="percentage-card-title">{title}</p>
      <div className="percentage-card-value">
        <span
          style={{
            width: `${percentage}%`,
            backgroundColor: color,
          }}
        ></span>
      </div>
      {userCount ? (
        <p className="percentage-card-percentage">{percentage}</p>
      ) : (
        <p className="percentage-card-percentage">{percentage}%</p>
      )}
    </div>
  );
};
const CardWarapper = ({ children }) => {
  return <div className="data-card">{children}</div>;
};

export default DataPopUp;
